<template>
  <basic-container id="carmonth20221227">
    <!--<el-form ref="searchForm" :model="query" label-width="100px" margin-top="0" :rules="rules">
      <el-col :span="4">
        <el-form-item label="停车场名称" prop="spaceId">
          <el-select v-model="query.spaceId" filterable placeholder="全部">
            <el-option
              style="padding-left: 10px;"
              v-for="item in spaceList"
              :key="item.value"
              :label="item.title"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="车牌号" prop="carNo">
          <el-input v-model="query.carNo" placeholder="请输入车牌号"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="车主名称" prop="customerName">
          <el-input v-model="query.customerName" placeholder="请输入车主姓名"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="车主电话" prop="customerPhone">
          <el-input v-model="query.customerPhone" placeholder="请输入车主电话"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="4">
        <el-form-item label="状态" prop="status">
          <el-select v-model="query.status" placeholder="全部">
            <el-option
              style="padding-left: 10px;"
              v-for="item in statusList"
              :key="item.dictKey"
              :label="item.dictValue"
              :value="item.dictKey"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="租赁起期 从" prop="dateRange">
          <el-date-picker
            v-model="query.dateStartRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="到"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="租赁止期 从" prop="dateRange">
          <el-date-picker
            v-model="query.dateEndRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="到"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>

      <el-col :span="5">
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="submitSearchForm">搜索</el-button>
          <el-button icon="el-icon-delete" @click="searchReset">清空</el-button>
        </el-form-item>
      </el-col>
    </el-form>-->
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      :upload-before="uploadBefore"
      :upload-after="uploadAfter"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
    <template slot="dateStartRangeSearch" slot-scope="scope">
    <div style="display: flex;">
        <el-date-picker
              style="width:42%;"
              v-model="query.buyStartTimeStart"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.buyStartTimeEnd"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
      </div>
      </template>
      <template slot="dateEndRangeSearch" slot-scope="scope">
    <div style="display: flex;">
        <el-date-picker
              style="width:42%;"
              v-model="query.buyEndTimeStart"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.buyEndTimeEnd"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
      </div>
      </template>
      <template slot="payTimeRangeSearch" slot-scope="scope">
    <div style="display: flex;">
        <el-date-picker
              style="width:42%;"
              v-model="query.payTimeStart"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.payTimeEnd"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
      </div>
      </template>
      <template slot="infoForm" slot-scope="scope">
        <avue-crud :option="infoOption" :data="infoData"></avue-crud>
      </template>
      <template slot-scope="scope" slot="carNoForm">
        <el-autocomplete
          style="width: 100%"
          v-model="form.carNo"
          :debounce="1000"
          @input="carNohandleBlur"
          placeholder="请输入车牌号"
          :trigger-on-focus="true"
          :disabled="carNoDisabledFlag"
          :fetch-suggestions="queryCarPayMonthCarNo"
          @select="selectCarPayCarNo"
        ></el-autocomplete>
      </template>
<!--      <template slot="menuLeft">-->
<!--        <el-button-->
<!--          type="primary"-->
<!--          icon="el-icon-plus"-->
<!--          v-if="permission.carmonth_review"-->
<!--          @click="openCarMonthReviewDialog"-->
<!--        >-->
<!--          审 核-->
<!--        </el-button>-->
<!--        &lt;!&ndash;        <el-button type="primary" icon="el-icon-plus" @click="openCarMonthPayDialog">&ndash;&gt;-->
<!--        &lt;!&ndash;          收 款&ndash;&gt;-->
<!--        &lt;!&ndash;        </el-button>&ndash;&gt;-->
<!--        &lt;!&ndash;        <el-button&ndash;&gt;-->
<!--        &lt;!&ndash;          type="primary"&ndash;&gt;-->
<!--        &lt;!&ndash;          icon="el-icon-plus"&ndash;&gt;-->
<!--        &lt;!&ndash;          v-if="permission.carmonth_change"&ndash;&gt;-->
<!--        &lt;!&ndash;          @click="openCarMonthChangeDialog"&ndash;&gt;-->
<!--        &lt;!&ndash;        >&ndash;&gt;-->
<!--        &lt;!&ndash;          车牌变更&ndash;&gt;-->
<!--        &lt;!&ndash;        </el-button>&ndash;&gt;-->
<!--        <el-button-->
<!--          type="success"-->
<!--          icon="el-icon-check"-->
<!--          v-if="permission.carmonth_synchronize"-->
<!--          @click="openCarMonthSynDialog"-->
<!--        >-->
<!--          同 步-->
<!--        </el-button>-->
<!--        &lt;!&ndash;        <el-button&ndash;&gt;-->
<!--        &lt;!&ndash;          type="danger"&ndash;&gt;-->
<!--        &lt;!&ndash;          plain&ndash;&gt;-->
<!--        &lt;!&ndash;          icon="el-icon-delete"&ndash;&gt;-->
<!--        &lt;!&ndash;          v-if="permission.carmonth_refund"&ndash;&gt;-->
<!--        &lt;!&ndash;          @click="openCarMonthRefundDialog"&ndash;&gt;-->
<!--        &lt;!&ndash;        >&ndash;&gt;-->
<!--        &lt;!&ndash;          退款注销&ndash;&gt;-->
<!--        &lt;!&ndash;        </el-button>&ndash;&gt;-->
<!--        <el-button type="primary" icon="el-icon-download" @click="openExportExcelDialog">-->
<!--          导 出-->
<!--        </el-button>-->
<!--      </template>-->
    </avue-crud>
    <!--    <el-dialog-->
    <!--      title="月卡车续约"-->
    <!--      :visible.sync="carMonthRenewShowDialogFlag"-->
    <!--      :modal-append-to-body="false"-->
    <!--      @opened="carMonthRenewDialogOpened"-->
    <!--    >-->
    <!--      <div class="el-property-dialog-div">-->
    <!--        <avue-form-->
    <!--          ref="carMonthRenewFormRef"-->
    <!--          v-model="carMonthRenewForm"-->
    <!--          :option="carMonthRenewOption"-->
    <!--          @reset-change="carMonthRenewReset"-->
    <!--          @submit="carMonthRenewSubmit"-->
    <!--        >-->
    <!--          <template slot-scope="scope" slot="menuForm">-->
    <!--            <el-button @click="quitCarMonthRenewDialog">退出</el-button>-->
    <!--          </template>-->
    <!--        </avue-form>-->
    <!--      </div>-->
    <!--    </el-dialog>-->
    <el-dialog
      title="月卡车审核"
      :visible.sync="carMonthReviewShowDialogFlag"
      :modal-append-to-body="false"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="carMonthReviewFormRef"
          v-model="carMonthReviewForm"
          :option="carMonthReviewOption"
          @reset-change="carMonthReviewReset"
          @submit="carMonthReviewSubmit"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="rejectCarMonthReviewDialog">驳回</el-button>
            <el-button @click="quitCarMonthReviewDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <!--    <el-dialog-->
    <!--      title="月卡车缴费"-->
    <!--      :visible.sync="carMonthPayShowDialogFlag"-->
    <!--      :modal-append-to-body="false"-->
    <!--      @opened="carMonthPayDialogOpened"-->
    <!--    >-->
    <!--      <div class="el-property-dialog-div">-->
    <!--        <avue-form-->
    <!--          ref="carMonthPayFormRef"-->
    <!--          v-model="carMonthPayForm"-->
    <!--          :option="carMonthPayOption"-->
    <!--          @reset-change="carMonthPayReset"-->
    <!--          @submit="carMonthPaySubmit"-->
    <!--        >-->
    <!--          <template slot-scope="scope" slot="menuForm">-->
    <!--            <el-button @click="quitCarMonthPayDialog">返回</el-button>-->
    <!--          </template>-->
    <!--        </avue-form>-->
    <!--      </div>-->
    <!--    </el-dialog>-->
    <el-dialog
      title="月卡车牌变更"
      :visible.sync="carMonthChangeShowDialogFlag"
      :modal-append-to-body="false"
      @opened="carMonthChangeDialogOpened"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="carMonthChangeFormRef"
          v-model="carMonthChangeForm"
          :option="carMonthChangeOption"
          @reset-change="carMonthChangeReset"
          @submit="carMonthChangeSubmit"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitCarMonthChangeDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      title="月卡车退费"
      :visible.sync="carMonthRefundShowDialogFlag"
      :modal-append-to-body="false"
      @opened="carMonthRefundDialogOpened"
      @close="quitCarMonthRefundDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="carMonthRefundFormRef"
          v-model="carMonthRefundForm"
          :option="carMonthRefundOption"
          @reset-change="carMonthRefundReset"
          @submit="carMonthRefundSubmit"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitCarMonthRefundDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog title="按条件导出" append-to-body :visible.sync="exportExcelFlag">
      <avue-form
        v-model="exportExcelForm"
        ref="exportExcelFormRef"
        :option="exportExcelOption"
        @submit="exportExcel"
      >
      </avue-form>
    </el-dialog>
    <carMonthExport
      ref="carMonthExport"
      v-bind:spaceList="spaceList"
      v-bind:statusList="statusList"
      v-bind:carTypeList="carTypeList"
    >
    </carMonthExport>
  </basic-container>
</template>
<script>
import {
  add,
  carMonthList,
  carMonthStartTime,
  getDetailAndOperate,
  getList,
  getRuleDetail,
  remove,
  synchronize,
  update,
  updateStatus,
  getDetail,
  copyCarmonth,
  loadCarPayMonthCarNo,
  nodeTreeByParentId,
} from '@/api/v4ward/car/carmonth';
import { getTreeChildrenNode } from '@/api/v4ward/deptproperty/basedeptproperty';
import { monthChargeRuleList } from '@/api/v4ward/car/carmonthchargerule';
import { getSpaceTree } from '@/api/v4ward/car/carparkspace';
import { lazyBasePropertyTree } from '@/api/v4ward/property/baseproperty';
import { mapGetters } from 'vuex';
import carMonthRenewOption from './carmonth-renew-option';
import carMonthReviewOption from './carmonth-review-option';
import exportExcelOption from './carmonth-exportExcel';
import carMonthPayOption from './carmonth-pay-option';
import carMonthChangeOption from './carmonth-change-option';
import carMonthRefundOption from './carmonth-refund-option';
import { getDictionary } from '../../../../api/common';
import carMonthExport from './carMonthExport';

export default {
  data() {
    return {
      reWrite: false,
      exportExcelFlag: false,
      carNoDisabledFlag: false,
      exportExcelOption: exportExcelOption,
      exportExcelForm: {},
      areaName: '',
      refundCheckBuyEndTime: true,
      refundCheckReturnMoney: true,

      iscarMonthRenewDialogFirstOpen: true,
      carMonthRenewShowDialogFlag: false,
      carMonthRenewForm: {},
      carMonthRenewOption: carMonthRenewOption,

      iscarMonthReviewDialogFirstOpen: true,
      carMonthReviewShowDialogFlag: false,
      carMonthReviewForm: {},
      carMonthReviewOption: carMonthReviewOption,

      iscarMonthPayDialogFirstOpen: true,
      carMonthPayShowDialogFlag: false,
      carMonthPayForm: {},
      carMonthPayOption: carMonthPayOption,

      iscarMonthChangeDialogFirstOpen: true,
      carMonthChangeShowDialogFlag: false,
      carMonthChangeForm: {},
      carMonthChangeOption: carMonthChangeOption,

      iscarMonthRefundDialogFirstOpen: true,
      carMonthRefundShowDialogFlag: false,
      carMonthRefundForm: {},
      carMonthRefundOption: carMonthRefundOption,

      buyStartTimeTemp: '',
      buyEndTimeTemp: '',
      editFlag: false,
      regionFirstIdTemp: '',
      form: {
        regions: '',
      },
      query: {
        spaceId: '',
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      firstDisplayFlag: false,
      tempSpaceId: '',
      selectionList: [],
      spaceList: [],
      statusList: [],
      carTypeList: [],
      option: {
        height: 'auto',
        menu:false,
        searchShow: true,
        searchMenuSpan: 6,
        //calcHeight: 30,
        align: 'center',
        indexLabel: '序号',
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        columnBtn: false,
        refreshBtn: false,
        addBtn: false,
        column: [
          {
            label: '车场名称',
            type: 'tree',
            prop: 'spaceId',
            span: 8,
            editDisabled: true,
            search: true,
            cell: true,
            clearable: false,
            props: {
              label: 'title',
              value: 'key',
            },
            rules: [
              {
                message: '请选择车场名称',
                required: true,
              },
            ],
            cascaderIndex:1,
            dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',
            change: ({ value, column }) => {
              this.emptyBasePerson();
            },
          },
          {
            label: '车牌号',
            prop: 'carNo',
            editDisabled: true,
            formslot: true,
            search: true,
            filterable:false,
            span: 8,
            rules: [
              {
                required: true,
                message: '请输入车牌号',
                trigger: 'change',
              },
              {
                pattern: this.$validation.carPlate,
                message: '车牌号格式错误',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '通行区域',
            prop: 'regions',
            hide: true,
            span: 8,
            type: 'tree',
            multiple: true,
            checkStrictly: true,
            dataType: 'string',
            dicData: [],
            props: {
              label: 'title',
              value: 'id',
            },
            rules: [
              {
                required: true,
                message: '请选择通行区域',
                trigger: 'change',
              },
            ],
          },
          // {
          //   label: '车辆分类',
          //   span: 8,
          //   type: 'select',
          //   dicUrl: '/api/blade-system/dict/dictionary?code=car_class',
          //   disabled: true,
          //
          //   props: {
          //     label: 'dictValue',
          //     value: 'dictKey',
          //   },
          //   rules: [
          //     {
          //       required: true,
          //       message: '请选择车辆分类',
          //       trigger: 'change',
          //     },
          //   ],
          //   dataType: 'number',
          //   prop: 'carClass',
          //   editDisabled: true,
          // },
          // {
          //   label: '车辆类型',
          //   //editDisabled: true,
          //   span: 8,
          //   type: 'select',
          //   dicUrl: '/api/blade-system/dict/dictionary?code=car_type',
          //   props: {
          //     label: 'dictValue',
          //     value: 'dictKey',
          //   },
          //   dataType: 'number',
          //   prop: 'carType',
          //   //editDisabled: true,
          //   rules: [
          //     {
          //       required: true,
          //       message: '请选择车辆类型',
          //       trigger: 'change',
          //     },
          //   ],
          // },
          {
            label: '车位编号',
            prop: 'lotNo',
            hide: true,
            maxlength: 30,
            showWordLimit: true,
            disabled: true,
            span: 8,
            rules: [
              {
                required: false,
                message: '请输入停车车位编号',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '应收金额',
            prop: 'shouldMoney',
            precision: 2,
            width: 70,
            addDisplay: false,
            maxlength: 15,
            showWordLimit: true,
            mock: {
              type: 'number',
              max: 1,
              min: 2,
              precision: 2,
            },
            minRows: 0.01,
            span: 8,
            disabled: true,
          },
          {
            label: '优惠金额',
            hide: true,
            disabled: true,
            prop: 'cutMoney',
            span: 8,
            precision: 2,
            addDisplay: false,
            mock: {
              type: 'number',
              max: 1,
              min: 2,
              precision: 2,
            },
            minRows: 0,
          },
          {
            label: '支付金额',
            prop: 'payMoney',
            span: 8,
            disabled: true,
            addDisplay: false,
            precision: 2,
            maxlength: 15,
            showWordLimit: true,
            mock: {
              type: 'number',
              max: 1,
              min: 2,
              precision: 2,
            },
            minRows: 0.01,
          },
          {
            label: '车主id',
            prop:'customerId',
            hide: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay:false,
          },
          {
            label: '收费套餐',
            prop: 'ruleName',
            display: false,
            addDisplay: false,
          },
          {
            label: '收费套餐',
            prop: 'ruleId',
            type: 'tree',
            hide: true,
            //editDisabled: true,
            dicData: [],
            span: 16,
            props: {
              label: 'remark',
              value: 'id',
            },
            rules: [
              {
                required: true,
                message: '请选择收费套餐',
                trigger: 'change',
              },
            ],
          },
          {
            label: '客户姓名',
            span: 8,
            prop: 'customerName',
            width: 70,
            maxlength: 10,
            showWordLimit: true,
            disabled: true,
            search: true,
            rules: [
              {
                required: true,
                message: '请输入客户姓名',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '客户手机',
            prop: 'customerPhone',
            search: true,
            width: 100,
            span: 8,
            disabled: true,
            rules: [
              { pattern: /^[0-9]*[0-9][0-9]*$/, message: '手机号格式错误' },
              {
                trigger: 'blur',
                min: 11,
                max: 11,
                message: '请输入11位手机号码',
              },
              {
                required: true,
                message: '请输入手机号',
                trigger: 'blur',
              },
            ],
          },
          // {
          //   label: '状态',
          //   prop: 'status',
          //   width: 70,
          //   type: 'select',
          //   dicUrl: '/api/blade-system/dict/dictionary?code=car_month_status',
          //   props: {
          //     label: 'dictValue',
          //     value: 'dictKey',
          //   },
          //   dataType: 'number',
          //   span: 8,
          //   editDisplay: false,
          //   addDisplay: false,
          //   rules: [
          //     {
          //       // required: true,
          //       message: '请输入同步标识  0未同步  1已同步',
          //       trigger: 'change',
          //     },
          //   ],
          // },
          {
            label: '支付方式',
            addDisplay: false,
            editDisplay: false,
            prop: 'payType',
            disabled: true,
            span: 8,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=pay_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            rules: [
              {
                required: true,
                message: '请输入支付方式',
                trigger: 'change',
              },
            ],
          },
          {
            label: '支付时间',
            prop: 'payOrRefundTime',
            span: 8,
            width: 100,
            type: 'date',
            display: false,
            /* addDisplay: false,*/
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            editDisabled: true,
          },
          {
            label: '收款单号',
            prop: 'payId',
            hide: true,
            span: 8,
            display: false,
            rules: [
              {
                required: true,
                message: '请输入收款单主键',
                trigger: 'change',
              },
            ],
          },
          {
            label: '退款单号',
            span: 8,
            display: false,
            hide: true,
            prop: 'returnId',
            rules: [
              {
                required: true,
                message: '请输入退款单主键',
                trigger: 'change',
              },
            ],
          },
          {
            label: '退费标识',
            prop: 'returnFlag',
            span: 8,
            display: false,
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入退费标识',
                trigger: 'change',
              },
            ],
          },
          {
            label: '退费金额',
            prop: 'returnMoney',
            span: 8,
            display: false,
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入退费金额',
                trigger: 'change',
              },
            ],
          },
          {
            label: '租赁起期',
            prop: 'buyStartTime',

            span: 8,
            width: 100,
            type: 'date',
            /* addDisplay: false,*/
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 00:00:00',
            //editDisabled: true,
            rules: [
              {
                required: true,
                message: '请输入租赁起期',
                trigger: 'change',
              },
            ],
          },
          {
            label: '租赁止期',
            prop: 'buyEndTime',
            type: 'date',
            width: 100,
            //editDisabled: true,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 23:59:59',
            span: 8,
            /* disabled: true,*/
            /* addDisplay: false,*/
            rules: [
              {
                required: true,
                message: '请输入租赁止期',
                trigger: 'change',
              },
              {
                validator: (rule, value, callback) => {
                  var dateStart = Date.parse(this.form.buyStartTime);
                  var dateEnd = Date.parse(value);
                  if (dateStart >= dateEnd) {
                    callback(new Error('租赁止期必须大于租赁起期！'));
                  } else {
                    callback();
                  }
                },
                trigger: 'change',
              },
            ],
          },
          {
            lazy: true,
            label: '房间',
            prop: 'areaId',
            // type: 'tree',
            hide: true,
            span: 16,
            display: false,
            // props: {
            //   labelText: '标题',
            //   label: 'objectFullName',
            //   value: 'key',
            //   children: 'children',
            // },
            // treeLoad: function (node, resolve) {
            //   const id = node.level === 0 ? 0 : node.data.id;
            //   lazyBasePropertyTree(id).then((res) => {
            //     resolve(
            //       res.data.map((item) => {
            //         return {
            //           ...item,
            //           leaf: !item.hasChildren,
            //         };
            //       })
            //     );
            //   });
            // },
            /*   rules: [
              {
                required: true,
                message: '请选择房间',
                trigger: 'change',
              },
            ],*/
          },
          {
            label: '房间',
            prop: 'areaName',
            hide: true,
            span: 16,
            disabled: true,
          },
          {
            label: '电子资料',
            prop: 'imgUrl',
            hide: true,
            type: 'upload',
            listType: 'picture-img',
            propsHttp: {
              res: 'data',
              url: 'link',
            },
            /*   canvasOption: {
              text: ' ',
              ratio: 0.1,
            },*/
            action: '/api/v4ward/oss/customEndpoint/put-file',
            tip: '只能上传jpg/png格式的图片，且不超过500kb',
            span: 24,
            row: true,
          },
          {
            label: '备注',
            prop: 'remark1',
            hide: true,
            span: 24,
            type: 'textarea',
            minRows: 2,
            maxlength: 200,
            showWordLimit: true,
            overHidden: true,
            rules: [
              {
                required: false,
                message: '请输入备注1',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注2',
            prop: 'remark2',
            hide: true,
            display: false,
            rules: [
              {
                required: true,
                message: '请输入备注2',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注3',
            prop: 'remark3',
            hide: true,
            display: false,
            rules: [
              {
                required: true,
                message: '请输入备注3',
                trigger: 'change',
              },
            ],
          },
          {
            addDisplay: false,
            editDisplay: false,
            label: '操作日志',
            prop: 'info',
            span: 24,
            hide: true,
            formslot: true,
          },
          {
            label: '租赁起期',
            prop: 'dateStartRange',
            span: 24,
            search: true,
            searchRange: true,
            searchslot: true,
            hide: true,
            display: false,
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
          },
          {
            label: '租赁止期',
            prop: 'dateEndRange',
            searchSpan: 6,
            search: true,
            searchRange: true,
            searchslot: true,
            hide: true,
            display: false,
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
          },
          {
            label: '支付时间',
            prop: 'payTimeRange',
            searchslot: true,
            searchSpan: 6,
            search: true,
            searchRange: true,
            hide: true,
            type: 'daterange',
            display: false,
            /* addDisplay: false,*/
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
          },
        ],
      },
      infoOption: {
        addBtn: false,
        menu: false,
        border: true,
        column: [
          {
            label: '操作类型',
            prop: 'operateType',
            type: 'select',
            dicData: [
              {
                label: '月卡车审核',
                value: 1,
              },
              {
                label: '新增月卡车',
                value: 2,
              },
              {
                label: '修改月卡车',
                value: 6,
              },
              {
                label: '月卡车退费',
                value: 4,
              },
              /* {
                label: '车辆续约',
                value: 5,
              },*/
              {
                label: '变更车牌',
                value: 3,
              },
              {
                label: '删除过期车辆',
                value: 7,
              },
              {
                label: '月卡车信息已同步至岗亭',
                value: 8,
              },
              {
                label: '补缴月卡车更新临停记录',
                value: 9,
              },
              /* {
                label: '缴费成功新增失败',
                value: 11,
              },*/
            ],
          },
          {
            label: '操作内容',
            prop: 'operateContent',
            width: 400,
          },
          {
            label: '操作人',
            prop: 'remark3',
            width: 100,
          },
          {
            label: '操作时间',
            prop: 'createTime',
          },
        ],
      },
      data: [],
    };
  },
  components: { carMonthExport },
  watch: {
    'form.spaceId'() {
      this.form.ruleId = '';
      let spaceIdTem = this.form.spaceId;
      if (this.vdui.isNotEmpty(spaceIdTem)) {
        monthChargeRuleList(Object.assign({ spaceId: spaceIdTem })).then(({ data }) => {
          const column = this.findObject(this.option.column, 'ruleId');
          column.dicData = data;
          /* const index = this.$refs.crud.findColumnIndex('ruleId');
              this.option.column[index].dicData = data;*/
        });

        nodeTreeByParentId(spaceIdTem).then((res) => {
          const column = this.findObject(this.option.column, 'regions');
          column.dicData = res.data;
          if(this.vdui.isEmpty(this.form.regions) && this.vdui.isNotEmpty(res.data)){
            this.regionFirstIdTemp = column.dicData[0].id;
            if(this.editFlag){
              this.form.regions = column.dicData[0].id;
            }
          }
        })
      }
    },
    'form.carType'(){
      const column = this.findObject(this.option.column, 'carType');
      if(this.form.status == 1){
        column.editDisabled=false;
      }else{
        column.editDisabled=true;
      }
    },
    'form.regions'(){
      const column = this.findObject(this.option.column, 'regions');
      if(this.form.status == 1){
        column.editDisabled=false;
      }else{
        column.editDisabled=true;
      }
    },
    'form.ruleId'(){
      const column = this.findObject(this.option.column, 'ruleId');
      //console.log(column)
      if(this.form.status == 1){
        column.editDisabled=false;
      }else{
        column.editDisabled=true;
      }
    },
    'form.buyStartTime'(){
      const column = this.findObject(this.option.column, 'buyStartTime');
      if(this.form.status == 1){
        column.editDisabled=false;
      }else{
        column.editDisabled=true;
      }
    },
    'form.buyEndTime'(){
      const column = this.findObject(this.option.column, 'buyEndTime');
      if(this.form.status == 1){
        column.editDisabled=false;
      }else{
        column.editDisabled=true;
      }
    },
    /* 'form.buyStartTime'() {
      if (this.vdui.isNotEmpty(this.form.buyStartTime)) {
        if (this.vdui.isNotEmpty(this.form.ruleId)) {
          getRuleDetail({ id: this.form.ruleId }).then(({ data }) => {
            let num = data.packageType;
            var startTime = new Date(this.form.buyStartTime);
            startTime.setMonth(startTime.getMonth() + num);
            this.form.buyEndTime = startTime.toISOString().slice(0, 10) + ' 23:59:59';
            this.form.shouldMoney = data.costPrice;
            this.form.cutMoney = 0;
            this.form.payMoney = this.form.shouldMoney - this.form.cutMoney;
          });
        } else {
          this.$message.success('请先选择收费套餐');
          return;
        }
      }
    },*/
    'carMonthRenewForm.spaceId'() {
      if (this.vdui.isNotEmpty(this.carMonthRenewForm.spaceId)) {
        carMonthList(Object.assign({ spaceId: this.carMonthRenewForm.spaceId }, this.query)).then(
          ({ data }) => {
            const index = this.$refs.carMonthRenewFormRef.findColumnIndex('carNo');
            this.carMonthRenewOption.column[index].dicData = data;
          }
        );
      }
    },
    'carMonthRenewForm.carNo'() {
      if (this.vdui.isNotEmpty(this.carMonthRenewForm.carNo)) {
        if (this.vdui.isNotEmpty(this.carMonthRenewForm.spaceId)) {
          carMonthStartTime(
            Object.assign(
              { spaceId: this.carMonthRenewForm.spaceId, carNo: this.carMonthRenewForm.carNo },
              this.query
            )
          ).then(({ data }) => {
            this.carMonthRenewForm.buyStartTime = data.startTime + ' 00:00:00';
            const index = this.$refs.carMonthRenewFormRef.findColumnIndex('ruleId');
            this.carMonthRenewOption.column[index].dicData = data.carMonthChargeRules;
            this.carMonthRenewForm.carType = data.carType;
            this.carMonthRenewForm.customerName = data.customerName;
            this.carMonthRenewForm.customerPhone = data.customerPhone;
            this.carMonthRenewForm.lotNo = data.lotNo;
            this.carMonthRenewForm.areaName = data.areaName;
            this.carMonthRenewForm.imgUrl = data.imgUrl;
            this.carMonthRenewForm.remark = data.remark;
          });
        }
      }
    },
    'carMonthRenewForm.ruleId'() {
      if (this.vdui.isNotEmpty(this.carMonthRenewForm.ruleId)) {
        if (this.vdui.isNotEmpty(this.carMonthRenewForm.buyStartTime)) {
          getRuleDetail({ id: this.carMonthRenewForm.ruleId }).then(({ data }) => {
            let num = data.packageType;
            var startTime = new Date(this.carMonthRenewForm.buyStartTime);
            startTime.setMonth(startTime.getMonth() + num);
            this.carMonthRenewForm.buyEndTime = startTime.toISOString().slice(0, 10) + ' 23:59:59';
            this.carMonthRenewForm.shouldMoney = data.costPrice;
            this.carMonthRenewForm.cutMoney = 0;
            this.carMonthRenewForm.payMoney =
              this.carMonthRenewForm.shouldMoney - this.carMonthRenewForm.cutMoney;
            this.carMonthRenewForm.status = 2;
          });
        }
      }
    },
    'carMonthPayForm.cutMoney'() {
      if (this.vdui.isNotEmpty(this.carMonthPayForm.cutMoney)) {
        this.carMonthPayForm.payMoney =
          this.carMonthPayForm.shouldMoney - this.carMonthPayForm.cutMoney;
      }
    },
    'carMonthRefundForm.returnMoney'() {
      if (this.vdui.isNotEmpty(this.carMonthRefundForm.returnMoney)) {
        // console.log(this.carMonthRefundForm.returnMoney);
        // console.log(this.carMonthRefundForm.payMoney);
        if (this.carMonthRefundForm.returnMoney > this.carMonthRefundForm.payMoney) {
          this.refundCheckReturnMoney = false;
          this.$message.error('退费金额不能超过支付金额!');
        } else this.refundCheckReturnMoney = true;
      }
    },
    'carMonthRefundForm.buyEndTime'() {
      if (this.vdui.isNotEmpty(this.carMonthRefundForm.buyEndTime)) {
        let time;
        let msg;
        if (this.carMonthRefundForm.buyStartTime > this.getToday()) {
          time = this.carMonthRefundForm.buyStartTime;
          msg = '租赁起期';
        } else {
          time = this.getToday();
          msg = '今天';
        }
        if (this.carMonthRefundForm.buyEndTime < time) {
          this.refundCheckBuyEndTime = false;
          this.$message.error('租赁止期不能小于' + msg + '!');
        } else this.refundCheckBuyEndTime = true;
      }
    },
    'carMonthReviewForm.carClass'() {
      /*const buyStartTimeColumn = this.findObject(this.carMonthReviewOption.column, 'buyStartTime');
      const buyEndTimeColumn = this.findObject(this.carMonthReviewOption.column, 'buyEndTime');*/
      /*if (this.carMonthReviewForm.carClass == 1) {
        buyStartTimeColumn.display = false;
        buyEndTimeColumn.display = false;
        this.carMonthReviewForm.buyStartTime = this.buyStartTimeTemp;
        this.carMonthReviewForm.buyEndTime = this.buyEndTimeTemp;
      }*/
      if (this.carMonthReviewForm.carClass == 2) {
        buyStartTimeColumn.display = true;
        buyEndTimeColumn.display = true;
      }
    },

  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.carmonth_add, false),
        viewBtn: this.vaildData(this.permission.carmonth_view, false),
        delBtn: this.vaildData(this.permission.carmonth_delete, false),
        editBtn: this.vaildData(this.permission.carmonth_edit, false),
      };
    },
    infoData() {
      return this.form.info;
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  mounted() {
    // this.initData();
  },
  created() {
    getSpaceTree().then((data) => {
      this.spaceList = data.data;
      if (this.spaceList.length > 0) {
        this.option.column[0].dicData = data.data;
        this.option.column[0].searchValue = this.spaceList[0].id;
        this.query.spaceId = this.spaceList[0].id;
        this.tempSpaceId = this.spaceList[0].id;
        this.$nextTick(() => {
          this.reWrite = true;
        });
      } else {
        this.$nextTick(() => {
          this.reWrite = true;
        });
      }
      this.onLoad();
    });
    this.initStatusList();
    this.initCartypeList();
    // this.initDateEndRange();
  },
  methods: {
    carNohandleBlur() {
      if (this.vdui.isNotEmpty(this.form.carNo)) {
        if (this.vdui.isNotEmpty(this.form.spaceId)) {
          this.form.customerPhone = '';
          this.form.customerName = '';
          this.form.lotNo = '';
          this.form.areaName = '';
          this.form.areaId = '';
        } else {
          this.$message.error('请先选择车场！');
          this.form.carNo = '';
        }
      }
    },
    emptyBasePerson() {
      this.form.carNo = '';
      this.form.customerName = '';
      this.form.customerPhone = '';
      this.form.areaId = '';
      this.form.areaName = '';
      this.form.lotNo = '';
    },
    //查询车牌号
    queryCarPayMonthCarNo(qs, cb) {
      loadCarPayMonthCarNo({ communityId: this.form.spaceId, searchContent: qs }).then(
        ({ data }) => {
          if (this.vdui.isEmpty(data)) {
            cb([]);
            if (this.vdui.isNotEmpty(this.form.spaceId)) {
              this.$message.info('没有匹配到车辆信息！');
              this.form.carNo='';
            }
          } else {
            this._.forEach(data, (item) => {
              item.value = item.carNo;
            });
            cb(data);
          }
        }
      );
    },
    //选择车牌号
    selectCarPayCarNo(item) {
      this.form.carNo = item.carNo;
      this.form.customerPhone = item.customerPhone;
      this.form.customerName = item.customerName;
      this.form.lotNo = item.lotNo;
      this.form.areaName = item.areaName;
      this.form.areaId = item.areaId;
      this.form.customerId=item.customerId;
    },
    initData() {
      lazyBasePropertyTree('').then((res) => {
        const column = this.findObject(this.option.column, 'areaId');
        column.dicData = res.data;
      });
    },
    initStatusList() {
      getDictionary('car_month_status').then((data) => {
        this.statusList = data.data;
      });
    },

    initCartypeList() {
      getDictionary('car_type').then((data) => {
        this.carTypeList = data.data;
      });
    },
    getInitData() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (strDate < 10) {
        strDate = '0' + strDate;
      }
      var currentdate = year + '-' + month + '-' + strDate + ' 00:00:00';
      return currentdate;
    },
    // initDateEndRange() {
    //   this.query.dateEndRange = [this.getCurrentMonthFirst(), this.getCurrentMonthLast()];
    // },

    getToday: function () {
      var date = new Date();
      var month = parseInt(date.getMonth() + 1);
      var day = date.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      return date.getFullYear() + '-' + month + '-' + day + ' 00:00:00';
    },

    getCurrentMonthFirst: function () {
      var date = new Date();
      date.setDate(1);
      var month = parseInt(date.getMonth() + 1);
      var day = date.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      return date.getFullYear() + '-' + month + '-' + day;
    },
    getCurrentMonthLast: function () {
      var date = new Date();
      var currentMonth = date.getMonth();
      var nextMonth = ++currentMonth;
      var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
      var oneDay = 1000 * 60 * 60 * 24;
      var lastTime = new Date(nextMonthFirstDay - oneDay);
      var month = parseInt(lastTime.getMonth() + 1);
      var day = lastTime.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      return date.getFullYear() + '-' + month + '-' + day;
    },
    /**
     * 月卡车续约
     */
    // openCarMonthRenewDialog() {
    //   this.carMonthRenewShowDialogFlag = true;
    // },
    // quitCarMonthRenewDialog() {
    //   this.carMonthRenewShowDialogFlag = false;
    //   this.$refs.carMonthRenewFormRef.resetForm();
    // },
    // carMonthRenewSubmit(form, done) {
    //   this.$refs.carMonthRenewFormRef.validate((valid) => {
    //     if (valid) {
    //       form.operateType = 5;
    //       add(form).then(
    //         () => {
    //           this.onLoad();
    //           this.$message.success('操作成功!');
    //           this.carMonthRenewShowDialogFlag = false;
    //
    //           this.$refs.carMonthRenewFormRef.resetForm();
    //           done();
    //         },
    //         (error) => {
    //           console.log(error);
    //         }
    //       );
    //     }
    //   });
    // },

    /**
     * 月卡车审核
     */
    openCarMonthReviewDialog() {
      //初始化审核页面显示buyStartTimeColumn，buyEndTimeColumn，carType，后面根据逻辑动态显示和隐藏
      /*  const buyStartTimeColumn = this.findObject(this.carMonthReviewOption.column, 'buyStartTime');
      const buyEndTimeColumn = this.findObject(this.carMonthReviewOption.column, 'buyEndTime');*/
      const carTypeColumn = this.findObject(this.carMonthReviewOption.column, 'carType');
      /* buyStartTimeColumn.display = true;
      buyEndTimeColumn.display = true;*/
      carTypeColumn.display = true;

      if (this.selectionList.length !== 1 || this.selectionList[0].$status !== '待审核') {
        this.$message.warning('请选择一条[待审核]数据进行操作');
        return;
      }
      this.carMonthReviewForm = this.selectionList[0];
      this.buyStartTimeTemp = this.carMonthReviewForm.buyStartTime;
      this.buyEndTimeTemp = this.carMonthReviewForm.buyEndTime;

      //carClass==1则为月卡车，不显示起止时间
      // if (this.carMonthReviewForm.carClass == 1) {
      //   buyStartTimeColumn.display = false;
      //   buyEndTimeColumn.display = false;
      // }
      //carClass==2则为临时车，不显示车辆类型
      if (this.carMonthReviewForm.carClass == 2) {
        carTypeColumn.display = false;
      }
      this.carMonthReviewShowDialogFlag = true;
    },
    quitCarMonthReviewDialog(form, done) {
      this.carMonthReviewShowDialogFlag = false;
      this.$refs.carMonthReviewFormRef.resetForm();
    },

    //审核通过
    carMonthReviewSubmit(form, done) {
      this.$refs.carMonthReviewFormRef.validate((valid) => {
        if (valid) {
          //若为免费车，则状态直接变为3：正常
          if (form.carClass == 2) {
            form.status = 3;
          }
          //若为月卡车，则状态变为2：待付款
          if (form.carClass == 1) {
            form.status = 2;
          }
          form.operateType = 1;
          update(form).then(
            () => {
              this.onLoad();
              this.$message.success('操作成功!');
              this.carMonthReviewShowDialogFlag = false;
              this.$refs.carMonthReviewFormRef.resetForm();
              done();
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        }
      });
    },

    //审核驳回
    rejectCarMonthReviewDialog(form, done) {
      form = this.carMonthReviewForm;
      this.$refs.carMonthReviewFormRef.validate((valid) => {
        if (valid) {
          form.status = 1;
          form.operateType = 1;
          update(form).then(
            () => {
              this.onLoad();
              this.$message.success('操作成功!');
              this.carMonthReviewShowDialogFlag = false;
              this.$refs.carMonthReviewFormRef.resetForm();
              done();
            },
            (error) => {
              console.log(error);
            }
          );
        }
      });
    },

    /**
     * 月卡车缴费
     */
    // openCarMonthPayDialog() {
    //   if (this.selectionList.length !== 1 || this.selectionList[0].$status !== '待付款') {
    //     this.$message.warning('请选择一条[待付款]数据进行操作');
    //     return;
    //   }
    //   this.carMonthPayForm = this.selectionList[0];
    //   this.carMonthPayShowDialogFlag = true;
    //   this.carMonthPayForm.payMoney =
    //     this.carMonthPayForm.shouldMoney - this.carMonthPayForm.cutMoney;
    // },
    // quitCarMonthPayDialog(form, done) {
    //   this.carMonthPayShowDialogFlag = false;
    //   this.$refs.carMonthPayFormRef.resetForm();
    // },
    // carMonthPaySubmit(form, done) {
    //   this.$refs.carMonthPayFormRef.validate((valid) => {
    //     if (valid) {
    //       form.status = 3;
    //       form.operateType = 2;
    //       update(form).then(
    //         () => {
    //           this.onLoad();
    //           this.$message.success('操作成功!');
    //           this.carMonthPayShowDialogFlag = false;
    //
    //           this.$refs.carMonthPayFormRef.resetForm();
    //           done();
    //         },
    //         (error) => {
    //           console.log(error);
    //         }
    //       );
    //     }
    //   });
    // },

    /**
     * 月卡车牌变更
     */
    openCarMonthChangeDialog() {
      if (this.selectionList.length !== 1 || this.selectionList[0].$status !== '正常') {
        this.$message.warning('请选择一条[正常]数据进行操作');
        return;
      }
      this.carMonthChangeForm = this.selectionList[0];
      this.carMonthChangeShowDialogFlag = true;
    },
    quitCarMonthChangeDialog(form, done) {
      this.carMonthChangeShowDialogFlag = false;
      this.$refs.carMonthChangeFormRef.resetForm();
    },
    carMonthChangeSubmit(form, done) {
      this.$refs.carMonthChangeFormRef.validate((valid) => {
        if (valid) {
          form.operateType = 3;
          if (form.carNo === form.newCarNo) {
            this.$message.success('输入新车牌号与修改前一样!');
            this.carMonthChangeForm.newCarNo = ' ';
            return;
          }
          update(form).then(
            () => {
              this.onLoad();
              this.$message.success('操作成功!');
              this.carMonthChangeShowDialogFlag = false;

              this.$refs.carMonthChangeFormRef.resetForm();
              done();
            },
            (error) => {
              console.log(error);
            }
          );
        }
      });
    },
    /**
     * 月卡车退费
     */
    openCarMonthRefundDialog() {
      if (this.selectionList[0].carClass == 2) {
        this.$message.warning('免费车不允许退款，请重新操作！');
        return;
      }
      if (this.selectionList.length !== 1 || this.selectionList[0].$status !== '正常') {
        this.$message.warning('请选择一条[正常]数据进行操作！');
        return;
      }
      getDetail({ id: this.selectionList[0].id }).then(({ data }) => {
        this.carMonthRefundForm = data;
        this.carMonthRefundShowDialogFlag = true;
        let day1 = new Date();
        this.carMonthRefundForm.buyEndTime = day1.toISOString().slice(0, 10) + ' 23:59:59';
        this.carMonthRefundForm.returnMoney = 1;
      });
    },
    quitCarMonthRefundDialog(form, done, loading) {
      this.carMonthRefundShowDialogFlag = false;
      this.refundCheckReturnMoney = true;
      this.refundCheckBuyEndTime = true;
      this.$refs.carMonthRefundFormRef.resetForm();
    },
    carMonthRefundSubmit(form, done) {
      if (!this.refundCheckReturnMoney) {
        this.$message.error('请检查退费金额!');
        done();
        return;
      }
      if (!this.refundCheckBuyEndTime) {
        this.$message.error('请检查租赁止期!');
        done();
        return;
      }
      this.$refs.carMonthRefundFormRef.validate((valid) => {
        if (valid) {
          form.operateType = 4;
          update(form).then(
            () => {
              this.onLoad();
              this.$message.success('操作成功!');
              this.carMonthRefundShowDialogFlag = false;
              this.$refs.carMonthRefundFormRef.resetForm();
              done();
            },
            (error) => {
              console.log(error);
              done();
            }
          );
        }
      });
    },

    rowSave(row, loading, done) {
      add(row).then(
        () => {
          console.log(row);
          this.onLoad();
          this.$message.success('操作成功!');
          loading();
        },
        (error) => {
          window.console.log(error);
          done();
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      /*if (row.status !== 1) {
        this.$message.warning('只能对新增待审核状态进行操作');
        done();
        return;
      }*/

      if (!row.imgUrl) {
        // console.log(row.imgUrl);
        row.imgUrl = '';
      }
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          loading();
        },
        (error) => {
          window.console.log(error);
          done();
        }
      );
    },
    rowDel(row) {
      if (row.status !== 1) {
        this.$message.warning('只能对新增待审核状态进行操作');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    openCarMonthSynDialog() {
      let exeFlag = true;
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      /* this.selectionList.forEach((ele) => {
        if (ele.status != 3) {
          this.$message.error('请选择状态为正常的月卡车数据');
          exeFlag = false;
          throw new Error("LoopTerminates");
        }
      });*/
      for (let i = 0; i < this.selectionList.length; i++) {
        if (this.selectionList[i].status != 3) {
          this.$message.error('请选择状态为正常的月卡车数据');
          exeFlag = false;
          break;
        }
      }
      if (exeFlag) {
        this.$confirm('确定将选择进行同步?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return synchronize({ ids: this.ids });
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      }
    },

    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      this.carNoDisabledFlag = false;
      const column = this.findObject(this.option.column, 'areaId');
      column.label = '房间';
      this.editFlag = ['add','edit'].includes(type);

      if (['add'].includes(type)) {
        setTimeout(() => {
          this.form.buyStartTime = this.getInitData();
          this.form.carClass = 1;
        }, 0);
      }
      if (['edit', 'view'].includes(type)) {
        // 修改查看页面时，车牌禁止修改
        this.carNoDisabledFlag = true;
        getDetailAndOperate({ id: this.form.id }).then(({ data }) => {
          this.form = data;
          this.form.info = data.carMonthLogList;
          if (this.form.ruleId == -1) {
            this.form.ruleId = '';
          }
          if('edit' === type && this.vdui.isEmpty(this.form.regions)){
            this.form.regions = this.regionFirstIdTemp;
          }
          //修改页面变更字段label名称
          const column = this.findObject(this.option.column, 'areaId');
          column.label = '修改房间';
          if (['view'].includes(type)) {
            setTimeout(() => {
              let _el = document.querySelector(
                'div[id*="el-collapse-content"] > div > div > div:nth-child(17) > div > div > div > div.avue-upload.avue-upload--list.avue-upload--upload > div.el-upload.el-upload--picture-img'
              );
              _el.style.display = 'inline-block';
              _el.addEventListener('click', (e) => {
                setTimeout(() => {
                  _el.querySelector('div>div>span>i').style.color = '#fff';
                });
              });
            });
          }
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      //每次刷新页面时，开启车场搜索框默然显示第一个节点的名称
      this.firstDisplayFlag = true;
      this.onLoad();
    },
    submitSearchForm() {
      this.searchChange(this.query);
    },
    searchChange(params, done) {
      this.query.spaceId = params.spaceId;
      this.query.carNo = params.carNo;
      this.query.customerName = params.customerName;
      this.query.customerPhone = params.customerPhone;
    
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
  
      //如果加载列表时spaceId为空，则将spaceId置为当前的第一个车场
      if (this.query.spaceId == undefined || this.query.spaceId == '') {
        this.query.spaceId = this.tempSpaceId;
      }
      if (this.spaceList.length > 0) {
        getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
          ({ data }) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
            if (this.firstDisplayFlag) {
              let ent = document.querySelector('input[placeholder="车场名称"]');
              ent.value = this.spaceList[0].title;
              this.query.spaceId = this.spaceList[0].id;
              //关闭默然显示，重刷页面时才开启默认显示
              this.firstDisplayFlag = false;
            }
          }
        );
      } else {
        this.loading = false;
      }
    },

    //打开导出弹框
    openExportExcelDialog() {
      // this.exportExcelFlag = true;
      // this.$refs.exportExcelFormRef.resetForm();
      // this.exportExcelForm = this.query;
      this.exportExcelForm.spaceId = this.query.spaceId;
      this.exportExcelForm.carNo = this.query.carNo;
      this.exportExcelForm.status = this.query.status;
      this.exportExcelForm.customerName = this.query.customerName;
      this.exportExcelForm.customerPhone = this.query.customerPhone;
      this.exportExcelForm.dateStartRange = [this.query.buyStartTimeStart,this.query.buyStartTimeEnd]
      this.exportExcelForm.dateEndRange = [this.query.buyEndTimeStart,this.query.buyEndTimeEnd];
      this.exportExcelForm.payTimeRange = [this.query.payTimeStart,this.query.payTimeEnd];
      this.exportExcel(this.exportExcelForm);

    },
    //按条件导出
    exportExcel(form, done) {

      var values = { ...form };
      console.log(values)
      console.log(this.query)
      //debugger;
      const { dateStartRange, dateEndRange,payTimeRange } = form;
      if (dateStartRange.length > 0) {
        values = {
          ...values,
          buyStartTimeStart: dateStartRange[0],
          buyStartTimeEnd: dateStartRange[1],
        };
        this.form.dateStartRange = null;
        values.dateStartRange = null;
      }
      if (dateEndRange.length > 0) {
        values = { ...values, buyEndTimeStart: dateEndRange[0], buyEndTimeEnd: dateEndRange[1] };
        values.outTime = null;
        this.form.dateEndRange = null;
      }
      if (payTimeRange.length > 0) {
        values = { ...values, payTimeStart: payTimeRange[0], payTimeEnd: payTimeRange[1] };
        values.payTimeRange = null;
        this.form.payTimeRange = null;
      }
      this.$refs.carMonthExport.carMonthExportExcel(values);
      done();
    },
    uploadBefore(file, done, loading) {
      let len = file.name.split('.').length;
      // const isImage = file.type === 'image/jpeg' || file.type === 'image/png';
      const isImage =
        (file.name.split('.')[len - 1] === 'png' || file.name.split('.')[len - 1] === 'jpg') &&
        (file.type === 'image/jpeg' || file.type === 'image/png');

      const isLt500KB = file.size / 1024 < 500;
      if (!isImage) {
        this.$message.error('只能上传jpg/png格式的图片');
        loading();
        return;
      }
      if (!isLt500KB) {
        this.$message.error('上传图片大小不能超过500kb!');
        loading();
        return;
      }
      if (isImage && isLt500KB) {
        done();
      }
    },
  },
};
</script>

<style>
.avue-upload--upload .el-upload{
    display: inline-block !important;
}
</style>
